export enum GraphQueryExecutionErrorCode {
    QUERY_EXECUTION_FAILED = "QUERY_EXECUTION_FAILED"
}